var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 0.281259C17.2477 0.277744 17.9543 1.25509 17.6168 2.22188C17.3426 3.00235 17.0508 3.77931 16.766 4.55626C15.2859 8.60274 13.7953 12.6422 12.3258 16.6922C11.9672 17.6801 10.9231 17.9719 10.1918 17.5184C9.91759 17.3461 9.73126 17.107 9.59767 16.8117C8.76095 14.9238 7.92423 13.0359 7.07696 11.1516C7.03477 11.0531 6.93282 10.9547 6.8379 10.9125C4.95353 10.0688 3.06563 9.23556 1.17774 8.39532C0.232041 7.97345 -0.0351468 6.86251 0.622275 6.11017C0.826181 5.87462 1.09688 5.75509 1.38165 5.65313C3.68087 4.81642 5.97657 3.97618 8.27579 3.13243C10.7578 2.2254 13.2399 1.31485 15.7254 0.407822C15.8906 0.348056 16.0699 0.323447 16.2422 0.281259Z",
    fill: "#3A3A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoving);
export default __webpack_public_path__ + "static/media/moving.44b4845f9f06c7063d99e424ba0719bb.svg";
export { ForwardRef as ReactComponent };